module.exports = __webpack_public_path__ + "img/dl1.729d3363.png";